import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  AfterViewInit,
  HostListener,
  OnDestroy,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() configuration!: ChartConfiguration;

  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;

  @HostListener('window:resize')
  onResize(): void {
    if (this.chart) {
      this.chart.resize();
    }
  }

  chart!: Chart;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['configuration'] && !changes['configuration'].firstChange) {
      this.initChart();
    }
  }

  ngAfterViewInit(): void {
    this.initChart();
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  private initChart(): void {
    if (this.chart) {
      this.chart.destroy();
    }

    if (!this.configuration) {
      return;
    }

    this.chart = new Chart(this.chartCanvas.nativeElement, {
      ...this.configuration,
      options: {
        ...this.configuration.options,
        responsive: true,
        maintainAspectRatio: false
      }
    });
  }
}
